import { Injectable } from '@angular/core';
import { AppSettings, AsamcoAuthService } from '@asamco/base';
import { bind } from '@asamco/utils';
import { Observable, Subject } from 'rxjs';

import { AsamcoSignalrBase } from '@asamco/signal-r';
import { LinkStatusCode } from '../../enums/link-status-code.enum';
import { LinkStatus } from '../../interfaces/link-status.interface';
import { LinkButtonStatus } from '../../interfaces/link-button-status.interface';
import { HubConnectionState } from '@microsoft/signalr';

@Injectable({
	providedIn: 'root',
	deps: [AsamcoAuthService, AppSettings],
})
export class LinkStatusSignalrService extends AsamcoSignalrBase {
	/**
	 * Our hubname to connect to
	 */
	protected hubName = 'linkStatus';

	/**
	 * The event name
	 */
	protected events = [
		{ methodName: 'linkStatusUpdate', newMethod: this.linkStatusUpdate },
		{ methodName: 'linkButtonUpdate', newMethod: this.linkButtonUpdate },
		{ methodName: 'mapperRunProgress', newMethod: this.mapperRunProgress },
		{ methodName: 'mapperRunCompleted', newMethod: this.mapperRunCompleted }
	];
	//protected buttonUpdate = [{ methodName: 'linkButtonUpdate', newMethod: this.linkButtonUpdate }];

	private linkStatusSubject: Subject<LinkStatus> = new Subject<LinkStatus>();
	private linkButtonSubject: Subject<LinkButtonStatus>  = new Subject<LinkButtonStatus>();
	private mapperRunProgressSubject: Subject<{ linkId: number; sessionId: string; stage: string; processedCount: number; totalCount: number; message: string }> = new Subject<{ linkId: number; sessionId: string; stage: string; processedCount: number; totalCount: number; message: string }>();
	private mapperRunCompletedSubject: Subject<{ linkId: number; sessionId: string }> = new Subject<{ linkId: number; sessionId: string }>();

	/**
	 *Creates an instance of NotificationSignalrService.
	 * @param signalr
	 * @param auth
	 * @param app
	 */
	constructor(auth: AsamcoAuthService, app: AppSettings) {
		super(auth, app);
	}

	@bind
	linkButtonUpdate(linkID: number, linkIsRunning: boolean) {
		this.linkButtonSubject.next({ linkID: linkID, isLinkRunning: linkIsRunning } as LinkButtonStatus);
	}

	@bind
	linkStatusUpdate(linkID: number, status: string, statusCode: LinkStatusCode) {
		this.linkStatusSubject.next({ linkID, status, statusCode } as LinkStatus);
	}

	@bind
	mapperRunProgress(linkId: number, sessionId: string, stage: string, processedCount: number, totalCount: number, message: string) {
		this.mapperRunProgressSubject.next({ linkId, sessionId, stage, processedCount, totalCount, message });
	}

	@bind
	mapperRunCompleted(linkId: number, sessionId: string) {
		this.mapperRunCompletedSubject.next({ linkId, sessionId });
	}

	public getLinkStatusObservable(): Observable<LinkStatus> {
		return this.linkStatusSubject.asObservable();
	}

	public getLinkButtonObservable(): Observable<LinkButtonStatus> {
		return this.linkButtonSubject.asObservable();
	}

	public getMapperRunProgressObservable(): Observable<{ linkId: number; sessionId: string; stage: string; processedCount: number; totalCount: number; message: string }> {
		return this.mapperRunProgressSubject.asObservable();
	}

	public getMapperRunCompletedObservable(): Observable<{ linkId: number; sessionId: string }> {
		return this.mapperRunCompletedSubject.asObservable();
	}

	joinCompany(companyId) {
		return this.hubConnection.invoke('joinCompany', companyId);
	}

	leaveCompany(companyId) {
		if(this.hubConnection.state !== HubConnectionState.Connected) {
			return Promise.resolve(true);
		} else {
			return this.hubConnection.invoke('leaveCompany', companyId);
		}
	}

	joinAdmins() {
		return this.hubConnection.invoke('joinAdmins');
	}

	leaveAdmins() {
		if(this.hubConnection.state !== HubConnectionState.Connected) {
			return Promise.resolve(true);
		} else {
			return this.hubConnection.invoke('leaveAdmins');
		}
	}
}
